import $ from 'jquery';

export const SRPAsyncStrategy = {
  NEW: 'new',
  LEGACY: 'legacy',
};

const dsp = (global.dsp = global.dsp || {});
dsp.srp_async_strategy = SRPAsyncStrategy.NEW;

function updateSRPAsyncStrategy() {
  const strategy = $('[data-srp-async-strategy]').data('srp-async-strategy');
  if (strategy) {
    dsp.srp_async_strategy = strategy;
  }
}

export function getSRPAsyncStrategy() {
  return dsp?.srp_async_strategy ?? SRPAsyncStrategy.NEW;
}

export function isSRPAsyncStrategy(strategy) {
  return getSRPAsyncStrategy() === strategy;
}

// load strategy on page ready, defaults to 'new'
$(document).ready(updateSRPAsyncStrategy);
